<template>
  <div class="loading-content">
    <div
      class="c-loading"
      :style="{
        border: `7px solid ${background}`,
        borderTopColor: color,
        borderLeftColor: color,
        width: `${size}px`,
        height: `${size}px`,
      }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    color: {
      type: String,
      default: 'var(--secondary-color-alternative, var(--primary-color-normal))',
    },
    background: {
      type: String,
      default: '#d7d7d7',
    },
    size: {
      type: Number,
      default: 100,
    },
  },
});
</script>

<style scoped lang="scss">
.loading-content {
  max-width: max-content;
  overflow: hidden;
}
.c-loading {
  border-radius: 50%;
  animation: loading 1s linear infinite;
  margin: 1rem;
}

@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
</style>
